import React, { useEffect, useRef, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { instance } from '../../store/utils';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

const Reports = props => {
  const user = useSelector(state => state.user);
  const groups = useSelector(state => state.user?.groups);
  const userType = 'provider';
  const [url, setUrl] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState('');
  const providerList = ['Search Vouchers', 'My Vouchers', 'My Offers'];
  const ktpList = [
    'Overview',
    'Applications',
    'Search Vouchers',
    'My Vouchers',
    'My Offers',
  ];
  const [usersList, setUsersList] = useState([]);

  useEffect(() => {
    setUsersList(providerList);
    setActivePage(providerList[0]);
  }, [user]);

  const getPowerBiLink = async () => {
    // console.log("ENTERED");
    return await instance
      .get(`/app/rest/reports/${userType}`)
      .then(response => {
        // console.log("ENTERED",response);
        return response;
      });
  };

  useEffect(() => {
    getPowerBiLink().then(data => {
      setToken(data.data.embedToken.token);
      setUrl(data.data.embedReports.embedUrl);
    });
  }, []);

  const reportRef = useRef(null);

  const navigateToPage = async pageName => {
    setActivePage(pageName);
    const report = reportRef.current?._embed;
    if (report) {
      const pages = await report.getPages();
      const page = pages.find(p => p.displayName === pageName);
      if (page) {
        await page.setActive();
      }
    }
  };

  const [reportConfig, setReportConfig] = useState({
    type: 'report',
    embedUrl: undefined,
    accessToken: undefined,
    id: undefined,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      background: models.BackgroundType.Transparent,
      navContentPaneEnabled: false,
    },
  });

  useEffect(() => {
    if (token !== '' && url !== '') {
      setReportConfig({
        ...reportConfig,
        embedUrl: url,
        accessToken: token,
        id: url
          .toString()
          .substring(
            url.toString().indexOf('=') + 1,
            url.toString().indexOf('&')
          ),
        filters:
          userType === 'provider'
            ? [
                {
                  $schema: 'http://powerbi.com/product/schema#basic', //"http://powerbi.com/product/schema#advanced"
                  target: {
                    table: 'provider_offer', //table name
                    column: 'provider', //table column name for filter
                  },
                  operator: 'In', //eq, in etc
                  values: [user?.info?.provider], //array of values eg. [123,49],
                },
              ]
            : [],
      });
      setLoading(false);
    }
  }, [token, url]);

  return loading ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div>
      <div className="custom-nav">
        {usersList.map(item => (
          <button
            className={activePage === item ? 'active' : ''}
            onClick={() => navigateToPage(item)}
          >
            {item}
          </button>
        ))}
      </div>
      <div className="powerbi-report-style-class">
        <PowerBIEmbed
          ref={reportRef}
          cssClassName={'report-style-class'}
          embedConfig={reportConfig}
        />
      </div>
    </div>
  );
};

export default Reports;
